<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" elevation="0" class="all-trade-tab rounded-0">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'" v-model="model">
      <v-tab class="px-0 ml-0" :href="`#tab-1`">
        All
      </v-tab>
      <v-tab :href="`#tab-2`"> Copied </v-tab>
      <v-tab :href="`#tab-3`"> Followed </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <AllTabs></AllTabs>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <CopiedTabs></CopiedTabs>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <FollowedTabs></FollowedTabs>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>
<script>
import AllTabs from './AllTabs.vue';
import CopiedTabs from './CopiedTabs.vue';
import FollowedTabs from './FollowedTabs.vue';

export default {
  components: {
    AllTabs,
    CopiedTabs,
    FollowedTabs,
  },
  data() {
    return {
      model: "tab-1",
    };
  },
  mounted() {
    if (this.$route.query.tab) {
      this.model = `tab-${this.$route.query.tab}`;
    }
  },
  watch: {
    model: function (newModel) {
      const tab = newModel.split('-')[1];
      const currentQuery = { ...this.$route.query };
      if (tab) {
        currentQuery.tab = tab;
        this.$router.push({ path: this.$route.path, query: currentQuery });
      }
    },
    '$route.query.tab': function (newTab) {
      if (newTab) {
        this.model = `tab-${newTab}`;
      } else {
        this.$router.push({ path: this.$route.path, query: { tab: null } });
      }
    },
  },
};
</script>